import { callGTMEvent } from './datalayer';
//MENU
$(document).ready(function() {
    //MOBILE NAV
    $('.btn-close-menu').on('click', function() {
        $('.menu-mobile-button').removeClass('active');
        $('body').removeClass('menu-active');
        $('.header-main').removeClass('active');
    });

    $('.menu-mobile-button').on('click', function() {
        $('.menu-main .menu-item').addClass('menu-item-hidden');
        $('.nav-main--titles .title-menu').addClass('d-none');
        if ($(this).hasClass('active')){
            // $(this).removeClass('active');
            // $('body').removeClass('menu-active');
            // $('.header-main').removeClass('active');    
        } else {
            $('.menu-mobile-button').removeClass('active');
            $(this).addClass('active');
            $('body').addClass('menu-active');
            $('.header-main').addClass('active');
        }
        if($(this).hasClass('menu-mobile-button-1')){
            $('.menu-main .menu-item:nth-child(1), .menu-main .menu-item:nth-child(2), .menu-main .menu-item:nth-child(3), .menu-main .menu-item:nth-child(4)').removeClass('menu-item-hidden');
            $('.nav-main--titles .title-menu-1').removeClass('d-none');
        } else if ($(this).hasClass('menu-mobile-button-2')) {
            $('.menu-main .menu-item:nth-child(5)').removeClass('menu-item-hidden');
            $('.menu-main .menu-item:nth-child(5) .menu-item-a').addClass('menu-item-a-open');
            $('.menu-main .menu-item:nth-child(5) .dropdown-group').removeClass('d-none d-lg-block');
            $('.menu-main .menu-item:nth-child(5) .column:first-child .dropdown-group:nth-child(2)').addClass('d-none d-lg-block');
            $('.nav-main--titles .title-menu-2').removeClass('d-none');
        } else if ($(this).hasClass('menu-mobile-button-3')) {
            $('.menu-main .menu-item:nth-child(5)').removeClass('menu-item-hidden');
            $('.menu-main .menu-item:nth-child(5) .menu-item-a').addClass('menu-item-a-open');
            $('.menu-main .menu-item:nth-child(5) .dropdown-group').addClass('d-none d-lg-block');
            $('.menu-main .menu-item:nth-child(5) .column:first-child .dropdown-group:nth-child(2)').removeClass('d-none d-lg-block');
            $('.nav-main--titles .title-menu-3').removeClass('d-none');
        } else if ($(this).hasClass('menu-mobile-button-4')) {
            $('.menu-main .menu-item:nth-child(6)').removeClass('menu-item-hidden');
            $('.menu-main .menu-item:nth-child(6) .menu-item-a').addClass('menu-item-a-open');
            $('.nav-main--titles .title-menu-4').removeClass('d-none');
        } else if ($(this).hasClass('menu-mobile-button-5')) {
            $('.menu-main .menu-item:nth-child(7), .menu-main .menu-item:nth-child(8)').removeClass('menu-item-hidden');
            $('.menu-main .menu-item:nth-child(7) .menu-item-a').addClass('menu-item-a-open');
            $('.nav-main--titles .title-menu-5').removeClass('d-none');
        } else {

        }
    });
    //MENU BUTTONS
    $('.menu-item-has-dropdown .menu-item-a').on('click', function() {
        $(this).toggleClass('menu-item-a-open');
    });

    //USER MENU BUTTON
    $('.top-menu--button').on('click', function() {
        $(this).toggleClass('active');
    });

    $(document).on('mouseup', '.top-menu--button.active, .top-menu--nav', function() {
        return false;
    });

    $(document).on('mouseup', function(e) {
        if ($(e.target).parent('.top-menu--button.active').length === 0) {
            $('.top-menu--button').removeClass('active');
        }
    });

    //SCROLL DOWN FUNCTION
    $('a.btn-scroll[href*=\\#]:not([href=\\#])').on('click', function() {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - $(this).attr('data-offset')
                }, 500);
                return false;
            }
        }
    });

    //ADD CLASS TO HEADER
    $('.header-page').addClass('active');

    //Current Year
    var CurrentYear = new Date().getFullYear();
    $('.current-year').text(CurrentYear);


  /**
   * General Pages Login Integration
   */
  let auth = JSON.parse(window.localStorage.getItem("userData"));
  let isUserLoggedIn = getCookie('wp_user_logged_in');
  if(isUserLoggedIn){
      $.ajax({
          method: 'POST',
          url: `${auth.root}my-plugin/v1/islogged`,
          data: { _wpnonce: auth.nonce },
          dataType: 'json',
          success: function ( data ) {
              var User = {...data};

              if(User.isLogged == true){
                  $('.login-btn').hide();
                  $('#topbar-username').html(`${User.username}`);
                  $('#section-login-component').hide();

                  if(User.prefs){
                        $('#latest-articles').addClass('col-sm-4').removeClass('col-md-6');
                        $('#news-updates').addClass('col-sm-4').removeClass('col-md-6');
                        $('#section-user-preferences-cta').hide();

                        $('#personalized-articles').find('.number').each(function(idx){
                            $(this).text(idx + 1)
                        })
                  } 

                  $('button#im-logout').on('click', function(){
                      callGTMEvent('im_logOut')
                      .then(() => {
                          window.location.href = User.logoutURL.replace('&amp;','&');
                          window.localStorage.removeItem("userData");
                      });
                  });
              }
          },
      })
  }
  else{
      $('.user-logged').hide();
      $('#section-user-preferences-cta').hide();
      window.localStorage.removeItem("userData");
  }
  
  // login
  // $(window).on('load', function() {
  //     if (typeof page_ajax !== 'undefined' &&
  //         typeof page_ajax['ims_Sign_Up_Login'] !== 'undefined')
  //     {
  //         var signUpLoginAction = page_ajax['ims_Sign_Up_Login'];
  //         var signUpLoginData = page_ajax['ims_Sign_Up_Login_Data'];
  //         if (signUpLoginAction && signUpLoginData) {
  //             callGTMEvent(signUpLoginAction, JSON.parse(signUpLoginData));
  //         }
  //         page_ajax['ims_Sign_Up_Login'] = '';
  //         page_ajax['ims_Sign_Up_Login_Data'] = '';
  //     }
  // });

  // logout 
  // $('button#im-logout').on('click', function(){
  //     var logoutUrl = $(this).attr('data-url');
  //     callGTMEvent('im_logOut')
  //     .then(() => {
  //       window.location.href = logoutUrl;
  //       window.localStorage.removeItem("userData");
  //     });
  // });
})

//function to get cookie by name
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}

